import { render, staticRenderFns } from "./TwoMoreLines.vue?vue&type=template&id=5313fceb&scoped=true&"
import script from "./TwoMoreLines.vue?vue&type=script&lang=js&"
export * from "./TwoMoreLines.vue?vue&type=script&lang=js&"
import style0 from "./TwoMoreLines.vue?vue&type=style&index=0&id=5313fceb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313fceb",
  null
  
)

export default component.exports